import React from "react";

const NotFound = () => {
  return (
    <div className="text-center">
      <img
        src="https://res.cloudinary.com/daxmjqsy2/image/upload/v1680158221/oops-404-error-with-broken-robot-concept-illustration_114360-5529_xnao6v.avif"
        alt="Page not found"
        className="img-fluid error"
      />
      <p className="error-msg">Page Not Found</p>
    </div>
  );
};

export default NotFound;
